import cloneDeep from "lodash/cloneDeep";

class CloneUtils {

    /**
     * @param {any} obj 
     * @returns not-null
     */
    static deepClone(obj) {
        return cloneDeep(obj)
    }

    /**
     * @param {any} obj 
     * @returns not-null
     */
    static deepCloneWithChange(obj, change) {
        const copy = cloneDeep(obj)
        return Object.assign(copy, change)
    }

}

export default CloneUtils